// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__28Wnx","disabled":"FileBtn_disabled__RExyu","warn":"FileBtn_warn__U57kh","fade":"FileBtn_fade__2vzxq"};